import { Address } from '$api-client/types.gen'

export const formatAddress = (address: Address) => {
  const parts = [
    address.line_one,
    address.line_two,
    address.city,
    address.post_code,
    address.country,
  ].filter(Boolean)

  return parts.join(', ')
}
